import { render, staticRenderFns } from "./StaffHoursUpload.vue?vue&type=template&id=e788b796&"
import script from "./StaffHoursUpload.vue?vue&type=script&lang=js&"
export * from "./StaffHoursUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports